import { render } from "./EditTransactionPage.vue?vue&type=template&id=bb06928a&ts=true"
import script from "./EditTransactionPage.vue?vue&type=script&lang=ts"
export * from "./EditTransactionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__